import { http } from 'http';

export default {
  deleteDocument: ({ container, folder, fileName }) =>
    http.delete(`/flex/docs/${container}/${folder}/${fileName}`)
};
